import React, { useState, useCallback } from 'react';

import MapGL, { Marker } from 'react-map-gl';

import MapIcon from '../../svg/pin.svg';
import { StandardBlockWrapper } from './standardBlockWrapper';
import { PortableTextBlock } from '../sanity/portableTextBlock';

const LocationMap = ({ lat, lng }) => {
  const [viewport, setViewport] = useState({
    zoom: 15,
    bearing: 0,
    pitch: 0,
    longitude: lng,
    latitude: lat,
  });

  const handleViewportChange = useCallback((newViewport) => {
    setViewport(newViewport);
  }, []);

  return (
    <MapGL
      {...viewport}
      width="100%"
      height="100%"
      mapStyle="mapbox://styles/luke-doig-brave/ckmmxm0yf1i2u17s6thca5xzy"
      mapboxApiAccessToken="pk.eyJ1IjoibHVrZS1kb2lnLWJyYXZlIiwiYSI6ImNqdnJmNXlyaTJkeWUzeXFqa2g1NDE1NDMifQ.9gZ0DygX_glVXLY6IsHjpA"
      onViewportChange={handleViewportChange}
    >
      <Marker latitude={lat} longitude={lng}>
        <MapIcon className="w-10" />
      </Marker>
    </MapGL>
  );
};

const ContactMap = ({ padding, backgroundColor, _rawText, location }) => {
  return (
    <StandardBlockWrapper
      padding={padding}
      backgroundColor={backgroundColor}
      className="grid grid-cols-14"
    >
      {/* Text */}
      <div className="col-start-2 col-end-14 prose md:prose-lg max-w-none md:col-start-3 md:col-end-7">
        <PortableTextBlock text={_rawText} />
      </div>
      {/* Map */}
      <div className="col-start-2 col-end-14 md:col-start-8 md:col-end-15 h-120 relative">
        <LocationMap {...location} />
      </div>
    </StandardBlockWrapper>
  );
};

export default ContactMap;
